import { setRange } from './helpers';

export const setHouseYear = setRange('house_year');
